import { apiFetch } from './prospects.js';

export function fetchMyCompanies() {
  return apiFetch('/companies/mine');
}

export function fetchCompanyConfiguration(companyId) {
  return apiFetch(`/companies/${encodeURIComponent(companyId)}/configuration`);
}

export function updateCompanyStancerKeys(companyId, payload) {
  return apiFetch(`/companies/${encodeURIComponent(companyId)}/configuration/stancer`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}

export function fetchCompanies() {
  return apiFetch('/companies');
}

export function createCompany(name) {
  return apiFetch('/companies', {
    method: 'POST',
    body: JSON.stringify({ name }),
  });
}

export function updateCompany(id, payload) {
  const body =
    typeof payload === 'string'
      ? { name: payload }
      : payload && typeof payload === 'object'
        ? payload
        : {};
  return apiFetch(`/companies/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function deleteCompany(id) {
  return apiFetch(`/companies/${encodeURIComponent(id)}`, {
    method: 'DELETE',
  });
}
